import './App.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

// ✅ Only import dark mode pages
import HomeDark from './pages/dark/Home';
import Blogs from './pages/dark/blogs';
import Works from './pages/dark/works';
import SingleProject from './pages/dark/single-project';
import SingleBlog from './pages/dark/single-blog';

function App() {
  return (
    <Router>
      <Routes>
        {/* ✅ Default route will directly load dark mode Home */}
        <Route path="/" element={<HomeDark />} />
        <Route path="/blogs" element={<Blogs />} />
        <Route path="/works" element={<Works />} />
        <Route path="/single-project" element={<SingleProject />} />
        <Route path="/single-blog" element={<SingleBlog />} />
      </Routes>
    </Router>
  );
}

export default App;
